import { render, staticRenderFns } from "./TapRoamers.vue?vue&type=template&id=39671efe"
import script from "./TapRoamers.vue?vue&type=script&lang=js"
export * from "./TapRoamers.vue?vue&type=script&lang=js"
import style0 from "./TapRoamers.vue?vue&type=style&index=0&id=39671efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports